import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from '../pages/Home';
import Register from '../components/auth/register/Register';
import Blogs from '../pages/Blogpage';
import EventPage from '../pages/EventsPage';
import CompanyList from '../pages/Companylistpage';
import ProductDetailPage from '../pages/Productdetailpage';
import CompanyDetailpage from '../pages/CompanyDetailpage';
import BlogDetailpage from '../pages/BlogDetailpage';
import EventDetailpage from '../pages/EventDetailpage';
import ProductListing from '../pages/ProductListing';
import PrivateRoute from './PrivateRoutes';
import PrivateHome from '../pages/PrivateHome';
import About from '../sections/home/About';
import Profile from '../pages/Profile/Profile';
import EditProfile from '../pages/Profile/EditProfile';
import NoProductFound from '../components/productlisting/NoProductFound';
import ForgotPassword from '../components/auth/ForgotPassword/ForgotPassword';
import OTPVerification from '../components/auth/ForgotPassword/OTPVerification';
import CreateNewPassword from '../components/auth/ForgotPassword/CreateNewPassword';
import Notification from '../layouts/Notification';

const Webrouter = ({ isAuthenticated }) => {
  return (
    <Routes>
      {/* Conditionally render the root route based on authentication */}
      <Route
        path="/"
        element={<Home  isAuthenticated={isAuthenticated}/>}
      />

      {/* Public Routes */}
      <Route path="/register" element={<Register />} />
      <Route path='/forgot-password' element={<ForgotPassword/>}/>
      <Route path='/forgot-password/otpverification' element={<OTPVerification/>}/>
      <Route path='/forgot-password/createnewpassword/' element={<CreateNewPassword/>}/>
      

      {/* <Route path='/about-section' element={<About/>}/> */}
      <Route path="/blogs" element={<Blogs  isAuthenticated={isAuthenticated}/>} />
      <Route path="/events" element={<EventPage isAuthenticated={isAuthenticated}/>} />

      {/* Private Routes */}
      <Route
        path="/blogdetail/:blogId"
        element={
          <PrivateRoute>
            <BlogDetailpage  isAuthenticated/>
          </PrivateRoute>
        }
      />
      <Route
        path="/notification"
        element={
          <PrivateRoute>
            <Notification  isAuthenticated/>
          </PrivateRoute>
        }
      />
      <Route 
      path='/noProduct'
      element={
        <PrivateRoute>
          <NoProductFound/>
        </PrivateRoute>
      }/>
      <Route 
      path='/profile'
      element={
        <PrivateRoute>
          <Profile/>
        </PrivateRoute>
      }
      />
      <Route 
      path='/editprofile'
      element={
        <PrivateRoute>
          <EditProfile/>
        </PrivateRoute>
      }
      />
      
      <Route
        path="/events/eventdetail/:eventId"
        element={
          <PrivateRoute>
            <EventDetailpage />
          </PrivateRoute>
        }
      />
      <Route
        path="/companylist"
        element={
          <PrivateRoute>
            <div className="mt-5 pt-5">
            <CompanyList />
            </div>
          </PrivateRoute>
          
        }
      />
      <Route
        path="/productlist"
        element={
          <PrivateRoute>
            <div className="mt-5 pt-5">
            <ProductListing  isAuthenticated={isAuthenticated}/>
            </div>
          </PrivateRoute>
        }
      />
      <Route
        path="/productdetail/:id"
        element={
          <PrivateRoute>
            <div className="mt-5 pt-5">
            <ProductDetailPage />
            </div>
          </PrivateRoute>
        }
      />
      <Route
        path="/companydetail/:id"
        element={
          <PrivateRoute>
            <div className="mt-5 pt-5">
              <CompanyDetailpage />
            </div>
          </PrivateRoute>
        }
      />

      {/* Fallback Route */}
      <Route path="*" element={<h1>Page Not Found</h1>} />
    </Routes>
  );
};

export default Webrouter;
